export default __webpack_public_path__ + "static/media/guia-3-3.3a9a8e0d.svg";